import { createResumePDF } from "./createResumePDF";

export const processUserWorks = async (props) => {
    // Respuesta que se entrega al final
    const response = { sucess: 0, data: [], message: "" }

    const { trabajos, registroReferencia } = props;

    await trabajos.forEach( async (work, index) => {
        console.log({work});
        const { trabTitulo, trabAutores, trabResumenTexto, trabPalabrasClave } = work;

        // Seteamos las variables a enviar al API
        let title = trabTitulo; 
        let authors = ""; // Se construye en el forEach
        let authorsProcedence = ""; // Se construye en el forEach
        let authorsEmails = ""; // Se construye en el forEach
        let content = trabResumenTexto;
        let keywords = trabPalabrasClave.trim();
        let fileName = `${registroReferencia}-${index + 1}.pdf`;

        /* Apellidos del primer autor, seguido de las Iniciales. 
        Siguientes autores inician con iniciales  y después apellidos.
        Usar conjunción "y" para el ultimo autor

        Ejemplo: Pérez-Fernández, R., L.H. Rodriguez-Vázquez y O. González-Chávez
        */
        trabAutores.forEach( (author, index) => {
            
            let initials = "";
            const namesArray = (author.autorNombres).split(' ');
            namesArray.forEach( n => {
                initials += n.slice(0, 1) + ".";
            });
            
            let familyNames = (author.autorApellidos).trim().replace(" ", "-");
            
            switch (index) {
                case 0:
                    authors += familyNames + ", " + initials + "#";
                    authorsProcedence += (author.autorProcedencia).trim() + ", ";
                    authorsEmails += (author.autorEmail).trim() + ", "; 
                    break;
                case (trabAutores.length - 1):
                    authors += " y " + initials + " " + familyNames;
                    authorsProcedence += (author.autorProcedencia).trim();
                    authorsEmails += (author.autorEmail).trim();
                    break;
                default:
                    authors += ", " + initials + " " + familyNames;
                    authorsProcedence += (author.autorProcedencia).trim() + ", ";
                    authorsEmails += (author.autorEmail).trim() + ", ";
                    break;
            }

        });
        authorsProcedence.trim(', ');
        authorsEmails.trim(', ');

        // Seteamos el URLLabel del elemento
        work.trabResumenURLLabel = `Trabajo ${index + 1}`;

        // Seteamos el URL del elemento con el resultado de la API
        work.trabResumenURL = `https://eventos.cibnor.mx/registro/apiServiciosSIARF/PDFDocuments/${fileName}`;


        // Seteamos los parametros y llamamos a la API
        const apiName = 'createResumeSimac2023';
        const values = {
            title: title,
            authors: authors, 
            authorsProcedence: authorsProcedence,
            authorsEmails: authorsEmails,
            content: content,
            keywords: keywords,
            fileName: fileName, 
        };
        const resultCreateResume = await createResumePDF({ values, apiName });
        console.log({resultCreateResume});

        /**
         * 
         * TODO: Comprobar que esta esperando la creacion del resumen
         * 
         */

        // Evaluamos el resultado, si hay error salir
        if (resultCreateResume.exito !== 1) {
            response.message = resultCreateResume.mensaje;
            return response;
        }

    });

    // Si llegamos hasta aqui significa que todo Ok
    response.sucess = 1;
    response.data = trabajos;

    return response;
};
